import { IntegrationRequirementsWebController } from '../controller/IntegrationRequirementsWebController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { IntegrationType } from '../../types/integration-type';

export class IntegrationRequirementsWebComponent extends BaseWebComponentElement {
  public controller!: IntegrationRequirementsWebController;
  private integrationType: IntegrationType;
  private nonUserConfigurable: Boolean;
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: IntegrationRequirementsWebController,
    });
  }
  public setIntegrationType(integrationType: IntegrationType) {
    this.integrationType = integrationType;
    this.controller.view.addIntegrationSpecificRequirements(integrationType);
  }

  public setNotConfigurableByUser(nonUserConfigurable: Boolean) {
    this.nonUserConfigurable = nonUserConfigurable;
  }

  public getIntegrationType(): IntegrationType {
    return this.integrationType;
  }

  public getNotConfigurableByUser(): Boolean {
    return this.nonUserConfigurable;
  }
}
